<template>
  <v-card class="pl-4 pr-2 py-2 card-border" elevation="0">
    <div class="d-flex ">
      <v-skeleton-loader type="image" width="100" height="100" />
      <div style="width: 50%" class="ms-2 mt-1">
        <v-skeleton-loader class="mb-2" type="text" max-width="100" />
        <v-skeleton-loader class="mb-2" type="sentences" max-width="300" />
        <v-skeleton-loader type="text" max-width="75" />
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'RoutineCardSkeleton',
}
</script>

<style lang="scss" scoped>
.card-border {
  border: 1px solid $color-blue-grey-lighten2;
}
</style>
